// extracted by mini-css-extract-plugin
export default {"postShare":"PostShare-module--postShare--50d6b","postShare__author":"PostShare-module--postShare__author--5307d"};